const EDIT_RECORD_DRAFT_PREFIX = 'admin:recordDraft:edit:'

const getSessionStorage = () => {
    if (typeof window === 'undefined') {
        return null
    }

    return window.sessionStorage
}

const normalizeStringValue = (value) => {
    if (value === undefined || value === null) {
        return ''
    }

    return String(value)
}

const normalizeStatusValue = (value, fallbackValue = 0) => {
    if (value === undefined || value === null || value === '') {
        return fallbackValue
    }

    const parsedValue = Number(value)

    return Number.isNaN(parsedValue) ? fallbackValue : parsedValue
}

// 완주기록증 신청 상세는 운영자가 다시 입력해야 하는 편집 필드만 sessionStorage에 남긴다.
export const createRecordDraftPayload = ({ params = {} } = {}) => {
    return {
        params: {
            username: normalizeStringValue(params.username),
            email: normalizeStringValue(params.email),
            number: normalizeStringValue(params.number),
            status: normalizeStatusValue(params.status, 0),
        }
    }
}

// 서버 기본값 위에 draft만 덮어써서 새로고침 뒤에도 수정 흐름을 이어간다.
export const applyRecordDraft = ({ baseParams = {}, draft }) => {
    const normalizedBaseDraft = createRecordDraftPayload({
        params: baseParams,
    })

    if (!draft) {
        return {
            params: {
                ...baseParams,
                ...normalizedBaseDraft.params,
            },
        }
    }

    const draftParams = draft.params || {}

    return {
        params: {
            ...baseParams,
            username: draftParams.username === undefined
                ? normalizedBaseDraft.params.username
                : normalizeStringValue(draftParams.username),
            email: draftParams.email === undefined
                ? normalizedBaseDraft.params.email
                : normalizeStringValue(draftParams.email),
            number: draftParams.number === undefined
                ? normalizedBaseDraft.params.number
                : normalizeStringValue(draftParams.number),
            status: draftParams.status === undefined
                ? normalizedBaseDraft.params.status
                : normalizeStatusValue(draftParams.status, normalizedBaseDraft.params.status),
        }
    }
}

export const createEditRecordDraftKey = (recordId) => `${EDIT_RECORD_DRAFT_PREFIX}${recordId}`

export const readRecordDraft = (draftKey) => {
    const storage = getSessionStorage()

    if (!storage || !draftKey) {
        return null
    }

    try {
        const storedValue = storage.getItem(draftKey)
        return storedValue ? JSON.parse(storedValue) : null
    } catch (_error) {
        return null
    }
}

export const saveRecordDraft = (draftKey, draftValue) => {
    const storage = getSessionStorage()

    if (!storage || !draftKey) {
        return
    }

    try {
        storage.setItem(draftKey, JSON.stringify(draftValue))
    } catch (_error) {
        // sessionStorage가 막혀 있어도 수정 흐름은 그대로 유지한다.
    }
}

export const clearRecordDraft = (draftKey) => {
    const storage = getSessionStorage()

    if (!storage || !draftKey) {
        return
    }

    try {
        storage.removeItem(draftKey)
    } catch (_error) {
        // storage 정리에 실패해도 화면 동작은 계속 진행한다.
    }
}
